import React from 'react';
import feedType from './config/feedTypes';
import FeedState from './states';

const feedContextInitialState = {
  onFeedSelected: () => {},
  selectedFeedType: feedType.CHECK_IN,
  feedClient: null,
  totalUnreadCount: { total: 0 },
  feedState: FeedState.FEED_NOT_INITIALIZED,
  onFeedError: () => {},
  onFeedRefresh: () => {},
  isFeedReady: false,
  onMarkAsRead: () => {},
  onMarkTaskComplete: () => {},
  onRestore: () => {},
  feedActivityList: [],
  actionError: false,
  setActionError: () => {},
  activityInProgress: [],
  uniqueClientNames: [],
  setSearchField: () => {},
  searchField: null,
  setIsOldestToNewest: () => {},
  isOldestToNewest: false,
  showAutomatedItems: false,
  setShowAutomatedItems: () => {},
  selectedActionBarType: null,
  setSelectedActionBarType: () => {},
  selectedActivity: null,
  setSelectedActivity: () => {},
  archivedActivityList: [],
  setIsSmartFeedbackSelected: () => {},
  isSmartFeedbackSelected: false,
  claimedChannelMap: new Map(),
  claimChannel: () => {},
  unclaimChannel: () => {},
  consolidatedToDoGroups: [],
  hasConsolidatedToDoError: false,
};

const FeedContext = React.createContext(feedContextInitialState);

export default FeedContext;
